<template>
  <v-footer height="auto">
    <v-layout justify-center footer row wrap hidden-sm-and-down>
        <v-container ma-0 pa-0 pt-5>
          <v-layout justify-center style="min-height: 280px">
            <v-flex>
              <v-toolbar color="footer" dark flat prominent>
                <img src="@/assets/logo-white-type.png" height="30"/>
                <v-spacer />
                <v-btn
                  flat
                  href="https://www.brainingcamp.com/about"
                  target="_blank"
                  class="btn_override"
                  v-if="!isStudent"
                >
                  About
                </v-btn>
                <v-btn
                  flat
                  href="https://www.brainingcamp.com/partners"
                  target="_blank"
                  class="btn_override"
                  v-if="!isStudent"
                >
                  Partners
                </v-btn>
                <v-btn
                  flat
                  href="https://www.brainingcamp.com/accessibility"
                  target="_blank"
                  class="btn_override"
                  v-if="!isStudent"
                >
                  Accessibility
                </v-btn>
                <v-btn
                  flat
                  href="https://www.brainingcamp.com/contact"
                  target="_blank"
                  class="btn_override"
                  v-if="!isStudent"
                >
                  Contact
                </v-btn>
                <v-btn
                  flat
                  href="https://www.brainingcamp.com/support"
                  target="_blank"
                  class="btn_override"
                  v-if="!isStudent"
                >
                  Support
                </v-btn>
                <v-spacer />
                <v-toolbar-items v-if="!isStudent">
                  <v-btn
                    fab
                    light
                    small
                    href="https://www.facebook.com/Brainingcamp"
                    target="_blank"
                    style="transform:scale(0.8)"
                  >
                    <i class="fab fa-facebook fa-2x" style="color: #072846"></i>
                  </v-btn>
                  <v-btn
                    fab
                    light
                    small
                    href="https://twitter.com/brainingcamp"
                    target="_blank"
                    style="transform:scale(0.8)"
                  >
                    <i class="fab fa-twitter fa-2x" style="color: #072846"></i>
                  </v-btn>
                  <v-btn
                    fab
                    light
                    small
                    href="https://www.youtube.com/user/Brainingcamp"
                    target="_blank"
                    style="transform:scale(0.8)"
                  >
                    <i class="fab fa-youtube fa-2x" style="color: #072846"></i>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <div style="min-height: 100px;"></div>
              <div style="padding-left:24px;">
                <div class="footer_item_small">
                  &copy; {{ new Date().getFullYear() }} Brainingcamp, LLC
                </div>
                <a href="https://www.brainingcamp.com/privacy-policy" target="_blank">
                <div class="footer_item_small" v-if="!isStudent">
                  Privacy Policy
                </div>
                </a>
                <a href="https://www.brainingcamp.com/terms-of-use" target="_blank">
                <div class="footer_item_small" v-if="!isStudent">
                  Terms of Use
                </div>
                </a>
              </div>
              <div style="padding-left:24px">
                <div class="footer_item_small">
                  Cuisenaire® and the sequence and selection of colors of all Cuisenaire® Rods are a registered trademark of hand2mind, Inc.
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
    
      <v-layout footer justify-center row wrap hidden-md-and-up py-5 text-xs-center>
        <v-flex xs12 my-3>
          <img src="@/assets/logo-white-type.png" height="34"/>
        </v-flex>
        <v-flex xs12 my-3>
          <v-btn
            flat
            dark
            href="https://www.brainingcamp.com/about"
            target="_blank"
            class="btn_override"
          >
            About
          </v-btn>
          <v-btn
            flat
            dark
            href="https://www.brainingcamp.com/partners"
            target="_blank"
            class="btn_override"
          >
            Partners
          </v-btn>
          <v-btn
            flat
            dark
            href="https://www.brainingcamp.com/accessibility"
            target="_blank"
            class="btn_override"
          >
            Accessibility
          </v-btn>
          <v-btn
            flat
            dark
            href="https://www.brainingcamp.com/contact"
            target="_blank"
            class="btn_override"
          >
            Contact
          </v-btn>
          <v-btn
            flat
            dark
            href="https://www.brainingcamp.com/support"
            target="_blank"
            class="btn_override"
          >
            Support
          </v-btn>
        </v-flex>
        <v-flex xs12 my-3>
          <v-btn
            fab
            light
            small
            href="https://www.facebook.com/Brainingcamp"
            target="_blank"
            style="transform:scale(0.8)"
          >
            <i class="fab fa-facebook fa-2x" style="color: #072846"></i>
          </v-btn>
          <v-btn
            fab
            light
            small
            href="https://twitter.com/brainingcamp"
            target="_blank"
            style="transform:scale(0.8)"
          >
            <i class="fab fa-twitter fa-2x" style="color: #072846"></i>
          </v-btn>
          <v-btn
            fab
            light
            small
            href="https://www.youtube.com/user/Brainingcamp"
            target="_blank"
            style="transform:scale(0.8)"
          >
            <i class="fab fa-youtube fa-2x" style="color: #072846"></i>
          </v-btn>
        </v-flex>
        <v-flex xs12 my-2 mt-3>
          <div class="footer_text_small">
            &copy; {{ new Date().getFullYear() }} Brainingcamp, LLC
          </div>
        </v-flex>
        <v-flex xs12 my-2>
          <a href="https://www.brainingcamp.com/privacy-policy" target="_blank">
            <div class="footer_text_small">
              Privacy Policy
            </div>
          </a>
        </v-flex>
        <v-flex xs12 my-2>
          <a href="https://www.brainingcamp.com/terms-of-use" target="_blank">
            <div class="footer_text_small">
              Terms of Use
            </div>
          </a>
        </v-flex>
        <v-flex xs12 mt-3>
          <div class="footer_text_small">
            Cuisenaire® and the sequence and selection of colors of all Cuisenaire® Rods are a registered trademark of hand2mind, Inc.
          </div>
        </v-flex>
      </v-layout>
  </v-footer>
</template>

<script>
export default {
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.token !== null
    },
    isStudent: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.role === 'student'
      }
      return false
    }
  }
}
</script>

<style scoped>
.footer_item_small {
  font-size: 14px;
  font-weight: 300;
  color: white;
  display: inline-block;
  margin-right: 24px;
}

.footer_text_small {
  font-size: 14px;
  font-weight: 300;
  color: white;
}

</style>
